<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 使用者管理
    .abilityGroup__item
      span.abilityGroup__subtitle 使用者管理頁面
      BaseAbilityRadioGroup(
        :value="abilityUserManagement"
        :disabled="disabled"
        @handleRadioChange="setAbilityUserManagement")
    .abilityGroup__item
      span.abilityGroup__subtitle 使用者行為頁面
      BaseAbilityRadioGroup(
        :value="abilityUserBehavior"
        :disabled="disabled"
        :uneditableAbility="true"
        @handleRadioChange="setAbilityUserBehavior")
    .abilityGroup__item
      span.abilityGroup__subtitle 職位管理
      BaseAbilityRadioGroup(
        :value="abilityPositionManagement"
        :disabled="disabled"
        @handleRadioChange="setAbilityPositionManagement")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityUserManagement: 'positionStore/getCurrentAbilityUserManagement',
      abilityUserBehavior: 'positionStore/getCurrentAbilityUserBehavior',
      abilityPositionManagement:
        'positionStore/getCurrentAbilityPositionManagement',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityUserManagement: 'positionStore/setAbilityUserManagement',
      setAbilityUserBehavior: 'positionStore/setAbilityUserBehavior',
      setAbilityPositionManagement:
        'positionStore/setAbilityPositionManagement',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupUserManagement.vue